import { render, staticRenderFns } from "./DialogModifyFile.vue?vue&type=template&id=b7042454&scoped=true"
import script from "./DialogModifyFile.vue?vue&type=script&lang=js"
export * from "./DialogModifyFile.vue?vue&type=script&lang=js"
import style0 from "./DialogModifyFile.vue?vue&type=style&index=0&id=b7042454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7042454",
  null
  
)

export default component.exports